import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { useDynamicModuleLoader } from 'shared/store'

import { authEndpoints } from './api'
import { UserProfile } from './types'

interface UserTokens {
  access: string
  // refresh: string //
}

export interface AuthSlice {
  phoneNumber: string
  user: UserProfile | null
  userTokens: UserTokens | null
}

const initialState: AuthSlice = {
  phoneNumber: '',
  user: null,
  userTokens: null,
}

export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload
    },
    setUserProfile: (state, action: PayloadAction<UserProfile | null>) => {
      state.user = action.payload
    },
    setUserToken: (state, action: PayloadAction<UserTokens | null>) => {
      state.userTokens = action.payload
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      authEndpoints.getMe.matchFulfilled,
      (state, { payload }) => {
        state.user = payload
      },
    )
  },
})

export const AuthSliceActions = authSlice.actions

export const AuthSliceReducer = authSlice.reducer

export const AuthSliceReducerState = {
  auth: AuthSliceReducer,
}

export interface AuthSliceSchema {
  auth?: AuthSlice
}

export const useAuthSlice = () =>
  useDynamicModuleLoader({
    reducers: { ...AuthSliceReducerState },
    removeAfterUnmount: false,
  })
